export const PageData = {
    introduction: {
        heading: "Introduction",
        text: [
            {
                id: 1,
                subtitle: "Opening: ",
                body: "Family reunification is one of the core principles of U.S. immigration law. If you're a U.S. citizen or permanent resident, you have the opportunity to petition for certain family members to join you in the United States.",
            },
            {
                id: 2,
                subtitle: "Goal: ",
                body: "This guide will walk you through the family-based immigration process and explain how GIT Global can help reunite your family.",
            },
        ]
    },

    body: [
        {
            heading: "Who Can You Bring to the U.S.?",
            id: 1,
            questions: [
                {
                    title: "For U.S. Citizens: ",
                    answer: [
                        {
                            id: 1,
                            text: "Immediate relatives: spouse, unmarried children under 21, and parents.",
                        },
                        {
                            id: 2,
                            text: "Other family members: adult children (married or unmarried) and siblings, but the process may take longer due to visa categories and caps.",
                        }
                    ]
                },
                {
                    title: "For Permanent Residents (Green Card Holders): ",
                    answer: [
                        {
                            id: 1,
                            text: "Spouse and unmarried children.",
                        },
                    ]
                },
            ]
        },

        {
            heading: "Step-by-Step Guide to Bringing Your Family to the U.S.",
            id: 2,
            questions: [
                {
                    title: "Step 1: File a Family Petition (Form I-130)",
                    answer: [
                        {
                            id: 1,
                            text: "U.S. citizens and permanent residents must file Form I-130, Petition for Alien Relative, to start the process of bringing a family member to the U.S.",
                        },
                    ]
                },
                {
                    title: "Required Documents:",
                    answer: [
                        {
                            id: 1,
                            text: "Proof of your U.S. citizenship or permanent residency (passport, Green Card, etc.).",
                        },
                        {
                            id: 2,
                            text: "Proof of family relationship (birth certificates, marriage certificates, etc.).",
                        },
                        {
                            id: 3,
                            text: "Passport photos and fees.",
                        },
                    ]
                },
                {
                    title: "Step 2: Wait for Visa Availability",
                    answer: [
                        {
                            id: 1,
                            text: "Immediate relatives of U.S. citizens (spouse, children under 21, parents) are not subject to visa caps, so their applications are processed more quickly.",
                        },
                        {
                            id: 2,
                            text: "For other family members, especially for Green Card holders, there are waiting periods depending on the family preference visa category and country of origin. Include a brief overview of visa categories (e.g., F1, F2A, F3, F4).",
                        },
                    ]
                },
                {
                    title: "Step 3: Consular Processing or Adjustment of Status",
                    answer: [
                        {
                            id: 1,
                            text: "If Your Family Member is Outside the U.S.: They will go through consular processing, where they apply for an immigrant visa at a U.S. consulate or embassy in their country.",
                        },
                        {
                            id: 2,
                            text: "If Your Family Member is Already in the U.S.: They may be able to adjust their status by filing Form I-485, Application to Register Permanent Residence or Adjust Status, without leaving the U.S.",
                        },
                    ]
                },
                {
                    title: "Step 4: Attend the Interview",
                    answer: [
                        {
                            id: 1,
                            text: "Your family member will be required to attend an interview at the U.S. consulate or USCIS office. This interview will involve questions about your relationship and the purpose of immigration.",
                        },
                        {
                            id: 2,
                            text: "Preparation Tips: Explain how GIT Global can assist in preparing the required documents and guiding the family member through the interview process.",
                        },
                    ]
                },
                {
                    title: "Step 5: Receive the Decision",
                    answer: [
                        {
                            id: 1,
                            text: "Once the visa is approved, your family member will receive an immigrant visa to travel to the U.S. After arrival, they will receive a Green Card in the mail.",
                        },
                        {
                            id: 2,
                            text: "If denied, you can appeal or reapply with the proper guidance from an immigration expert.",
                        },
                    ]
                },
            ]
        },
    ],

    conclusion: {
        heading: "How GIT Global Can Help You Bring Your Family to the U.S.",
        text: [
            {
                id: 1,
                subtitle: "Complete Guidance: ",
                body: "GIT Global helps with every step of the family-based immigration process, from completing the Form I-130 to preparing your family for consular interviews or adjustment of status applications.",
            },
            {
                id: 2,
                subtitle: "Document Preparation: ",
                body: "We assist in gathering all the necessary documentation, making sure that your family petition is error-free and complete to avoid delays.",
            },
            {
                id: 3,
                subtitle: "Ongoing Support: ",
                body: "Our experienced team will be by your side, answering questions and helping you overcome any challenges during the process.",
            },
        ]
    },
    
}
